import React,{ useState }  from "react";
import { Link,useNavigate } from "react-router-dom";
// import "./QuestionnairesForm.css";
import ContractFormModalContact from "./ContractFormModalContact";
import { useDispatch, useSelector } from "react-redux";
import { setTitle } from "../../redux/titleSlice";
// ContactFormHeader component for displaying a header with navigation and buttons
const  ContactFormHeader = ({ toggleSidebar }) => {

  // const [title, setTitle] = useState("Untitled Contract");
   const [isEditing, setIsEditing] = useState(false);
   
   const navigate = useNavigate();
   const title = useSelector((state) => state.title.title);
   const dispatch = useDispatch();
 
 
   const handleTitleClick = (e) => {
     e.preventDefault();
     setIsEditing(true);
   };
 
   const handleTitleChange = (e) => {
     dispatch(setTitle(e.target.value));
   };
 
   const handleBlur = () => {
     setIsEditing(false);
   };
 
   const handleKeyPress = (e) => {
     if (e.key === "Enter") {
       setIsEditing(false);
     }
   };
   
  
  return (<>
    <ContractFormModalContact />
    <nav className='navbar navbar-expand flex-column flex-md-row bottom-header-main  px-lg-5 px-2 py-2'>
      <div className=' d-flex align-items-center d-md-flex ms-md-2'>
        <div className='d-flex align-items-center bottom-header'>
          {/* Back arrow icon */}
          {/* <div className='icon'>
          <MdKeyboardArrowLeft />
        </div> */}
          {/* ====== Hamburger Button to Toggle The side Bar =========== */}
          <button
            className='sidebar-toggler flex-shrink-0 bg-transparent border-0 me-3'
            onClick={() => navigate(-1)}>
            <i className='fa fa-arrow-left' />
          </button>

          <Link to='/templates'  onClick={(e) => e.preventDefault()} >
          <div className='title-container' >
          <div className='title-container' onClick={handleTitleClick}>
              {/* Title */}
              {isEditing ? (
                <input
                  type='text'
                  value={title}
                  onChange={handleTitleChange}
                  onBlur={handleBlur}
                  onKeyPress={handleKeyPress}
                  autoFocus
                  className='editable-title'
                />
              ) : (
                <h5 className='untitled-product-title'>{title}</h5>
              )}
            </div>
             
            </div>
            <p className='d-flex align-items-center'>
              <i className='far fa-folder'></i>
              <Link to='/contact-form'> <span className='preview-text balck'>Contact Form</span></Link>
            </p>
          </Link>
        </div>
      </div>
      <div className='navbar-nav align-items-center ms-md-auto'>
        <div className='py-3 button_group  gy-3'>
          {/* Preview button */}
          <button className='mb-md-0 bg-white' id='preview1'>PREVIEW</button>
          {/* Use template button */}
          <button
              type="button"
              id="publish"
              onClick={() => window.dispatchEvent(new Event("publishContactForm"))}
            >
              PUBLISH
            </button>
        </div>
      </div>
    </nav>
    </>
  );
};

export default  ContactFormHeader;
